import { useEffect, useRef } from 'react'

import window from 'common/window'

import { removeRememberedUrl, setRememberedUrl } from './remembered-url'

const TrackRememberedUrl = () => {
  const url = window.location.href
  const lastRememberedUrl = useRef<string>()
  useEffect(() => {
    if (url !== lastRememberedUrl.current) {
      removeRememberedUrl()
      setRememberedUrl(url)
      lastRememberedUrl.current = url
    }
  }, [url])
  return null
}

export default TrackRememberedUrl
